import { Card, CardBody, CardFooter, CardHeader } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { useExperienceContext } from '../Experience';
import {
  ExperienceActionHint,
  ExperienceActions,
  ExperienceAlert,
  ExperienceAvailableLanguages,
  ExperienceCompetencies,
  ExperienceDescription,
  ExperiencePopoverContext,
  ExperienceTimeCommitment,
  ExperienceTitle,
  ExperienceUpcomingDates,
} from '../PopoverProgramExperience';
import { useExperienceEnrollmentContext } from '../ProgramExperienceEnrollment';
import ExperiencesStore from '../../DiscoveryPortal/ExperienceSelection/Experiences/ExperiencesStore';

interface Props {
  onClose: () => void;
  experiencesStore: ExperiencesStore;
}

function ExperienceVideoDetailsModalBody({ onClose, experiencesStore }: Props) {
  const { onOpen } = useExperienceEnrollmentContext();
  const { invitationUuid, experienceResource } = useExperienceContext();

  return (
    <ExperiencePopoverContext.Provider
      value={{
        invitationUuid,
        experienceResource,
        experiencesStore,
        onEnroll: () => {
          onOpen();
          onClose();
        },
      }}
    >
      <Card className="absolute inset-0 shadow-none" radius="none">
        <CardHeader className="px-6 pt-8 shadow-none sm:pt-0">
          <div className="flex flex-grow flex-col gap-y-3">
            <ExperienceAlert />
            <ExperienceTitle />
          </div>
        </CardHeader>
        <CardBody className="gap-y-4 px-6">
          <ExperienceTimeCommitment />
          <ExperienceAvailableLanguages />
          <ExperienceDescription />
          <ExperienceCompetencies />
          <ExperienceUpcomingDates />
        </CardBody>
        <CardFooter className="gap-y-2 px-6 pb-8 empty:pt-0">
          <ExperienceActions />
          <ExperienceActionHint />
        </CardFooter>
      </Card>
    </ExperiencePopoverContext.Provider>
  );
}

export default observer(ExperienceVideoDetailsModalBody);
